import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input,ElementRef } from '@angular/core';
import { IndicatorModel } from './Indicator.model';
import { ComboBoxComponent } from '../../../combo-box/combo-box.component';
import { TextBoxComponent } from '../../../text-box/text-box.component';
import { TextAreaComponent } from '../../../text-area/text-area.component';
import { CheckBoxComponent } from '../../../check-box/check-box.component';
import { HiddenComponent } from '../../../hidden/hidden.component';
// import { FileuploadComponent } from '../../../fileupload/fileupload.component';
import { DateComponent } from '../../../date/date.component';
import { ButtonComponent } from '../../../button/button.component';
import { AmountComponent } from '../../../amount/amount.component';
import { FormComponent } from '../../../form/form.component';
import { ToggleSwitchComponent } from '../../../toggle-switch/toggle-switch.component';
import { ButtongroupComponent } from '../../../buttongroup/buttongroup.component';
import { CardsgroupComponent } from '../../../cardsgroup/cardsgroup.component';
import { RangeBarComponent } from '../../../range-bar/range-bar.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PopupModalComponent } from '../../../popup-modal/popup-modal.component';
import { ServiceStock } from '../../../service-stock.service';
import { LabelComponent } from '../../../label/label.component';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';
import { RadioButtonComponent } from '../../../radio-button/radio-button.component';

const customCss: string = '';

@Component({
selector: 'app-Indicator',
templateUrl: './Indicator.component.html'
})
export class IndicatorComponent extends FormComponent implements OnInit, AfterViewInit {
@Output() indicatorSelected: EventEmitter<any> = new EventEmitter<any>();
@ViewChild('cmbIndicator', {static: false}) cmbIndicator: ComboBoxComponent;
skeletonContentLoaded = false; 
async revalidate(): Promise<number> {
var totalErrors = 0;
super.beforeRevalidate();
await Promise.all([
this.revalidateBasicField('cmbIndicator'),
]).then((errorCounts) => {
errorCounts.forEach((errorCount)=>{
totalErrors+=errorCount;
});
});
this.errors = totalErrors;
super.afterRevalidate();
return totalErrors;
}
constructor(services: ServiceStock){
super(services);
this.value = new IndicatorModel();
this.componentCode = 'Indicator';
}
setReadOnly(readOnly){
super.setBasicFieldsReadOnly(readOnly);
}
async onFormLoad(){
this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
this.cmbIndicator.setValue(this.services.dataStore.getData("indicatorID"));
this.setDependencies();
}
setInputs(param : any){
let params = this.services.http.mapToJson(param);
if(params['mode']){
this.mode = params['mode'];
}
}
async submitForm(path, apiCode, serviceCode){
this.submitData['formName'] = 'Indicator';
await super.submit(path, apiCode, serviceCode);
}
getFieldInfo() {
this.amountComponent.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
this.comboFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
// this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
return this.additionalInfo;
}
getFieldValue(){
return this.value;
}
setValue(inputValue, inputDesc=undefined) {
this.setBasicFieldsValue(inputValue, inputDesc);
this.value = new IndicatorModel();
this.value.setValue(inputValue);
this.setDependencies();
this.passNewValue(this.value);
}
ngOnInit(){
if(this.formCode == undefined) {this.formCode = 'Indicator';}
if(this.formOnLoadError){return;}
setTimeout(()=>{this.skeletonContentLoaded = true; 
}, 1000); 
var styleElement = document.createElement('style');
styleElement.type = 'text/css';
styleElement.innerHTML = customCss;
styleElement.id = 'Indicator_customCss';
document.getElementsByTagName('head')[0].appendChild(styleElement);
}
ngOnDestroy(){
this.unsubscribe$.next();
this.unsubscribe$.complete();
var styleElement = document.getElementById('Indicator_customCss');
styleElement.parentNode.removeChild(styleElement);
}
ngAfterViewInit(){
setTimeout(() => {
this.subsBFldsValueUpdates();
this.onFormLoad();
this.checkForHTabOverFlow();
});
}
clearError(){
super.clearBasicFieldsError();
super.clearHTabErrors();
super.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
}
onReset(){
super.resetBasicFields();
this.clearHTabErrors();
this.clearVTabErrors();
this.errors = 0;
this.errorMessage = [];
this.additionalInfo = undefined;
this.dependencyMap.clear();
this.value = new IndicatorModel();
this.passNewValue(this.value);
this.setReadOnly(false);
this.onFormLoad();
}
async cmbIndicator_change(event){
let inputMap = new Map();
this.indicatorSelected.emit({
});
}
fieldDependencies = {
}

}